export const COIN = "BPD";
export const GT = "MP";
export const LP = "UNI LP";
// export const LP = "RBTC/BPD LP";
